import VueI18n from 'vue-i18n'//需先安装vue-i18n
import Vue from 'vue'

Vue.use(VueI18n)

let langMessages = {
 zh: require('./lang/zh.json'),
 en: require('./lang/en.json')
}

let i18n = new VueI18n({
  locale: 'en',
  messages: langMessages
})

let lang = navigator.language||navigator.userLanguage;//常规浏览器语言和IE浏览器
lang = lang.substr(0, 2);//截取lang前2位字符
if(lang == 'zh'){
  i18n.locale = 'zh'
}else{
  i18n.locale = 'en'
}


const setLang = (lang) => {
  i18n.locale = lang
}
const getLang = () => {
  return i18n.locale
}


Vue.prototype.$setLang = setLang
Vue.prototype.$getLang = getLang

export default i18n


// WEBPACK FOOTER //
// ./src/i18n/index.js